import { MAT_COLOR_FORMATS, MatColorFormats } from 'src/app/_shared/modules/color-picker/services';

const CUSTOM_MAT_COLOR_FORMATS: MatColorFormats = {
  display: {
    colorInput: 'hex6',
  },
};

export const COLOR_PROVIDER = { provide: MAT_COLOR_FORMATS, useValue: CUSTOM_MAT_COLOR_FORMATS };
